import { createAction, props } from '@ngrx/store';

export const loginStart = createAction('[Auth] Login Start', props<{ username: string; password: string }>());

export const authentificateSuccess = createAction(
  '[Auth] Login Success',
  props<{
    username: string;
    userId: string;
    token: string;
    expirationDate: Date;
    redirect: boolean;
    isStaff?: boolean;
    isSuperuser?: boolean;
    groups?: string[];
  }>()
);

export const authentificateFail = createAction('[Auth] Login Fail', props<{ payload: string }>());

export const clearError = createAction('[Auth] Clear Error');

export const autoLogin = createAction('[Auth] Auto Login');
export const autoLoginFinished = createAction('[Auth] Auto Login Finished');

export const logout = createAction('[Auth] Logout');

export const orgoLoginStart = createAction('[Auth] Orgo Login Start');
export const orgoCallbackStart = createAction('[Auth] Orgo Callback Start', props<{ successToken: string }>());

export const updateGroups = createAction(
  '[Auth] Update Groups',
  props<{ groups: string[] }>()
);
